<template>
    <v-layout justify-center>
        <v-responsive max-width="1080" width="100%" height="100%" class="mx-n3 px-3">
            <list-heading title="라인 현황">
                <div slot="buttons" class="caption mb-n3">기준일: {{ date }}</div>
            </list-heading>
            <mes-dashboard-graphics v-bind="{ date, schedules, loading, categories }" />
            <mes-dashboard-calendar v-model="date" v-bind="{ type, events, categories }" v-on="{ typeChange }" />
        </v-responsive>
    </v-layout>
</template>

<script>
import dayjs from "dayjs";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import MesDashboardGraphics from "@/components/console/mes/mes-dashboard-graphics.vue";
import MesDashboardCalendar from "@/components/console/mes/mes-dashboard-calendar.vue";
import api from "@/api";

let CATEGORIES = {
    ["SMT 01라인"]: { category: "전자제조실장1라인", color: "#A3C614" },
    ["SMT 02라인"]: { category: "전자제조실장2라인", color: "#FFC13A" },
    ["보드조립 01라인"]: { category: "보드조립라인", color: "#FF6839" },
};

let categories = Object.values(CATEGORIES).map(({ category }) => category);

export default {
    components: {
        ListHeading,
        MesDashboardGraphics,
        MesDashboardCalendar,
    },
    data: () => ({
        date: Date.now().toDate(),
        type: "month",
        schedules: [],
        categories,

        loading: false,
    }),
    computed: {
        searchDateValue() {
            let start = dayjs(this.date).startOf("month");
            let end = dayjs(this.date).endOf("month");
            return [start, end].map((date) => date.toISOString());
        },
        events() {
            return this.schedules.map(({ LINE_NAME, TODAY_STR, MODEL_NAME, CUST_NAME, ...item }) => {
                let categoryData = CATEGORIES[LINE_NAME];
                let dates = { start: TODAY_STR, end: TODAY_STR };
                let name = `[${CUST_NAME}] ${MODEL_NAME}`;
                return { ...dates, name, ...item, ...categoryData };
            });
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        date() {
            this.search();
        },
    },
    methods: {
        typeChange(type) {
            this.type = type;
        },
        async search() {
            this.loading = true;
            try {
                let { searchDateValue } = this;
                this.schedules = (await api.console.mes.schedules.gets({ params: { searchDateValue } }))?.schedules;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
